import React from 'react'

const Cell = () => {
    return (
        <div className="cell">
            
        </div>
    )
}

export default Cell
